module.exports = __webpack_public_path__ + "static/media/menuBackgroundGreen.ba849779.svg";